import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 1.497h15s3 0 3 3v15s0 3-3 3h-15s-3 0-3-3v-15s0-3 3-3"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 12h2.248a.75.75 0 0 0 .531-1.28l-6.3-5.86a1.5 1.5 0 0 0-1.948 0L4.72 10.717A.75.75 0 0 0 5.25 12H7.5v6A1.5 1.5 0 0 0 9 19.5h6a1.5 1.5 0 0 0 1.5-1.5Z"
    }, null, -1)
  ]));
}
const computerKeyboardShift = { render };
export {
  computerKeyboardShift as default,
  render
};
//# sourceMappingURL=computer-keyboard-shift.svg.js.map
